import React from 'react';
import { motion } from 'framer-motion';

const StoreButtons = ({ 
  className = '', 
  showContactButton = false,
  layout = 'horizontal', // 'horizontal' or 'vertical'
  size = 'normal', // 'small' or 'normal'
  ...props 
}) => {
  const containerClass = `store-buttons ${layout === 'vertical' ? 'store-buttons--vertical' : ''} ${className}`;

  return (
    <div className={containerClass} {...props}>
      <motion.a
        href="https://play.google.com/store/apps/details?id=com.faizannadeem.splitnest"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-play-store"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Download SplitNest from Google Play Store"
      >
        <i className="fab fa-google-play" aria-hidden="true"></i>
        <div className="btn-text">
          <span className="main-text">GET IT ON</span>
          <span className="sub-text">Google Play</span>
        </div>
      </motion.a>
      
      <motion.a
        href="https://apps.apple.com/us/app/splitnest-bill-split-app/id6748543668"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-app-store"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Download SplitNest from Apple App Store"
      >
        <i className="fab fa-apple" aria-hidden="true"></i>
        <div className="btn-text">
          <span className="main-text">Download on the</span>
          <span className="sub-text">App Store</span>
        </div>
      </motion.a>
      
      {showContactButton && (
        <motion.a
          href="mailto:info@splitnest.org"
          className="btn btn-secondary"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Contact SplitNest support"
        >
          <i className="fas fa-envelope" aria-hidden="true"></i>
          <span>Contact Us</span>
        </motion.a>
      )}
    </div>
  );
};

export default StoreButtons;